import { render, staticRenderFns } from "./GMBRecommendations.vue?vue&type=template&id=8495d742&scoped=true"
import script from "./GMBRecommendations.vue?vue&type=script&lang=js"
export * from "./GMBRecommendations.vue?vue&type=script&lang=js"
import style0 from "./GMBRecommendations.vue?vue&type=style&index=0&id=8495d742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8495d742",
  null
  
)

export default component.exports